exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\np.message[data-v-079502b9]{width:80%;margin:0 auto\n}\n.flex[data-v-079502b9]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end\n}\n", "", {"version":3,"sources":["/builds/youx-group/sicarf/sicarf-parametrizavel/frontend/src/screens/portal/publico/AppModalVisualizarPdf.vue"],"names":[],"mappings":";AAyDA,2BACE,UACA,aAAc;CACf;AAAA,uBAGC,oBAAA,oBAAA,aACA,qBAAA,kBAAA,wBAAyB;CAC1B","file":"AppModalVisualizarPdf.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\np.message {\n  width: 80%;\n  margin: 0 auto;\n}\n\n.flex {\n  display: flex;\n  justify-content: flex-end;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-079502b9","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/screens/portal/publico/AppModalVisualizarPdf.vue
// module id = cbzb
// module chunks = 12